import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    containerVedioCard: {
      width: "339px",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerBodyCard: {
      display: "flex",
      flexDirection: "column",
      gap: "8px",
    },
    sectionMnueCategoryName: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      padding: "0px 24px",
    },
    sectionCreatedBy: {
      display: "flex",
      flexDirection: "row",
      padding: "8px 24px",
      gap: "10px",
    },
    containerItemAvatar: {
      border: `0.5px solid ${theme.palette.border.alpha_black_10}`,
      borderRadius: "50%",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    AvatarStyle: {
      width: "32px",
      height: "32px",
    },
    createdByTitle: {
      fontSize: "12px",
      fontWeight: 400,
      color: theme.palette.text.primary,
      lineHeight: "18px",
    },
    createdByValue: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    containerCreatedBy: {
      display: "flex",
      flexDirection: "column",
    },
    containerInfoProprety: {
      display: "flex",
      flexDirection: "row",
      padding: "16px 24px",
    },
    containerCountImages: {
      display: "flex",
      flexDirection: "row",
      gap: "4px",
    },
    totalCountValue: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.primary,
      lineHeight: "20px",
    },
    contaierImageProprety: {
      height: "240px",
      width: "339px",
      contain: "cover",
    },
    containerHeaderCard: {
      height: "240px",
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      position: "relative",
    },
    containerCategoryName: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "28px",
    },
    conatinerPlayPauseIcon: {
      position: "absolute",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      background: "rgba(0, 0, 0, 0.4)",
      backdropFilter: "blur(8px)",
      WebkitBackdropFilter: "blur(8px)",
    },
  };
});
